import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-role-delete",
  "use": "icon-role-delete-usage",
  "viewBox": "0 0 8 7.969",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 7.969\" id=\"icon-role-delete\">\r\n  <defs>\r\n    <style>\r\n      #icon-role-delete .cls-1 {\r\n        fill: #f05254;\r\n        fill-rule: evenodd;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <path id=\"icon-role-delete_删除_拷贝\" data-name=\"删除 拷贝\" class=\"cls-1\" d=\"M782.005,222.127l2.64,2.63a0.8,0.8,0,1,0,1.131-1.127L783.137,221l2.639-2.63a0.8,0.8,0,0,0-1.131-1.127l-2.64,2.629-2.64-2.629a0.8,0.8,0,1,0-1.132,1.127l2.64,2.63-2.64,2.63a0.8,0.8,0,0,0,1.132,1.127l2.64-2.629h0Zm0,0\" transform=\"translate(-778 -217.031)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/role-delete.svg
// module id = 6R4s
// module chunks = 127